import { render, staticRenderFns } from "./ViewDomain.vue?vue&type=template&id=b057f144&"
import script from "./ViewDomain.vue?vue&type=script&lang=js&"
export * from "./ViewDomain.vue?vue&type=script&lang=js&"
import style0 from "./ViewDomain.vue?vue&type=style&index=0&id=b057f144&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports